import { Drawer, DrawerClose, DrawerContent, DrawerTitle } from "@worship-devo/ui";
import { CloseIcon } from "packages/ui/src/icons";

import { close as closeSupportChat, HUBSPOT_INLINE_EMBED_ELEMENT_ID } from "~/lib/support-chat";
import { useSupportChatStore } from "~/stores/useSupportChatStore";

export function SupportDrawer() {
  const isOpen = useSupportChatStore((state) => state.isOpen);
  const hasEverOpened = useSupportChatStore((state) => state.hasEverOpened);
  const isLoading = useSupportChatStore((state) => state.isLoading);
  const closeDrawer = useSupportChatStore((state) => state.close);

  // Lazy-mount: no HubSpot DOM exists until the user has opened support once.
  if (!hasEverOpened) {
    return null;
  }

  const handleOpenChange = (next: boolean) => {
    if (next) return;
    closeSupportChat();
    closeDrawer();
  };

  return (
    <Drawer open={isOpen} onOpenChange={handleOpenChange}>
      <DrawerContent
        hideHandle
        className="mx-auto max-w-[640px] bg-twi-gray-900 lg:h-[620px] lg:max-h-[85dvh]"
        childrenClassname="flex h-full min-h-0 flex-col p-6"
        data-testid="support-drawer"
      >
        <div className="mb-4 flex items-start justify-between gap-4">
          <DrawerTitle className="font-semibold text-white text-xl leading-[110%]">Contact Support</DrawerTitle>
          <DrawerClose
            className="shrink-0 cursor-pointer rounded-full bg-twi-gray-950 p-1.5 text-twi-gray-400 transition-colors hover:text-white"
            data-testid="support-drawer-close"
          >
            <CloseIcon />
            <span className="sr-only">Close</span>
          </DrawerClose>
        </div>

        <div className="relative flex h-full min-h-[500px] w-full flex-1 flex-col">
          <div
            id={HUBSPOT_INLINE_EMBED_ELEMENT_ID}
            data-testid="support-drawer-embed-target"
            className="flex h-full w-full flex-1 flex-col justify-end"
          />
          {isLoading ? (
            <div
              className="absolute inset-0 flex flex-col items-center justify-center gap-3 rounded-xl bg-twi-gray-900"
              data-testid="support-drawer-loader"
              role="status"
              aria-live="polite"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="size-12 animate-spin text-primary ease-in-out"
                aria-hidden="true"
              >
                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                <path d="M12 3a9 9 0 1 0 9 9" />
              </svg>
              <p className="text-sm text-twi-gray-400">Loading support chat…</p>
            </div>
          ) : null}
        </div>
      </DrawerContent>
    </Drawer>
  );
}
